import React, { useState, useEffect, useCallback } from 'react';
import { Drawer } from 'antd';
import FilterSelect from "components/Form/filterSelect";
import { useSelector } from 'react-redux';
import FilterDate from "components/Form/dateFilterInput";
import { Button } from 'components/Button';

const StockHistoryFilterDrawer = ({
    handleFilterDrawer,
    showFilterDrawer,
    handleFilterChange,
    filters,
    handleApplyFilter,
    filterLoading,
    handleDateChange
}) => {
    const [placement] = useState('right');
    const {
        userData, userDataLoading,
        uniformSizes, uniformSizesLoading
    } = useSelector((state) => state.common);

    const [userDataOption, setUserDataOption] = useState([]);
    const [sizeOption, setSizeOption] = useState([]);

    useEffect(() => {
        let _userData = userData?.map(item => {
            return {
                label: item.first_name + " " + item.last_name,
                value: item.id
            };
        });

        const sizeOrder = ["XS", "S", "M", "L", "XL", "XXL"];
        let _sizes = uniformSizes ? [...uniformSizes] : [];
        _sizes.sort((a, b) => sizeOrder.indexOf(a.code) - sizeOrder.indexOf(b.code));

        let _sizeOptions = _sizes.map(item => {
            return {
                label: item.name + " (" + item.code + ")",
                value: item.id
            };
        });

        setUserDataOption(_userData);
        setSizeOption(_sizeOptions);
    }, [userData, uniformSizes]);

    const setFilterValue = useCallback((key) => {
        if (filters.length) {
            let selectedValue = [...filters].find(item => item.key === key);
            if (selectedValue?.value) {
                return selectedValue;
            }
        }
        return "";
    }, [filters]);

    return (
        <>
            <Drawer
                title="Stock History Filters"
                placement={placement}
                closable={true}
                onClose={handleFilterDrawer}
                open={showFilterDrawer}
                key={placement}
            >
                <div className="col mb-3 d-flex justify-content-between">
                    <h3 className="page-title">Filters</h3>
                    <i onClick={handleFilterDrawer} className='la la-close cursor-pointer' />
                </div>

                <div className='col-12 mb-3'>
                    {/* Size Filter */}
                    <FilterSelect
                        isClearable={true}
                        onChange={e => { handleFilterChange(e, "size") }}
                        optionLabel={"label"}
                        optionValue={'value'}
                        options={sizeOption}
                        value={setFilterValue("size")}
                        placeholder={"Select Size"}
                        isLoading={uniformSizesLoading}
                    />
                </div>

                <div className='col-12 mb-3'>
                    {/* Created By Filter */}
                    <FilterSelect
                        isClearable={true}
                        onChange={e => { handleFilterChange(e, "created_by") }}
                        optionLabel={"label"}
                        optionValue={'value'}
                        options={userDataOption}
                        value={setFilterValue("created_by")}
                        placeholder={"Select Created By"}
                        isLoading={userDataLoading}
                    />
                </div>

                <div className='col-12 mb-3'>
                    {/* Stock Date Filter */}
                    <FilterDate
                        onChange={e => { handleDateChange(e, "stock_date") }}
                        value={setFilterValue("stock_date")?.value || ""}
                        placeholder={"Stock Date"}
                        label={"Stock Date"}
                    />
                </div>

                <div className="col-12">
                    <Button
                        label="Search"
                        loading={filterLoading}
                        disabled={filterLoading}
                        onClick={handleApplyFilter}
                        className="btn btn-primary w-100"
                    />
                </div>
            </Drawer>
        </>
    );
};

export default StockHistoryFilterDrawer;

